<template>
  <div class="col-lg-3 col-md-3 col-sm-12">
    <div class="sidebar sidebar-left">
      <div class="widget">
        <ul class="nav nav-tabs nav-stacked service-menu">
          <li :class="buildingActive">
            <a href="/services/building">Building services</a>
          </li>
          <li :class="paintingingActive">
            <a href="/services/painting">Painting services</a>
          </li>
          <li :class="electricalActive">
            <a href="/services/electrical"
              >Electrical Wiring & Maintenance services</a
            >
          </li>
          <li :class="landscapingActive">
            <a href="/services/landscaping">Landscaping & Paving services</a>
          </li>
          <li :class="plumbingActive">
            <a href="/services/plumbing">Plumbing & decor services</a>
          </li>
          <li :class="tilingActive">
            <a href="/services/tilling">Tilling services</a>
          </li>
          <li :class="swimmingActive">
            <a href="/services/swimmingpool"
              >Swimming pool construction services</a
            >
          </li>
          <li :class="aluminiumActive">
            <a href="/services/aluminum"
              >Aluminium fabrication & installation services</a
            >
          </li>
          <li :class="carpentryActive">
            <a href="/services/carpentry">Carpentery & roofing services</a>
          </li>
          <li :class="fabricationActive">
            <a href="/services/fabrication">Steel fabrication services</a>
          </li>
          <li :class="householdActive">
            <a href="/services/householdfittings"
              >Household fittings services</a
            >
          </li>
          <li :class="architecturalActive">
            <a href="/services/architectural"
              >Architectural & foundation setting services</a
            >
          </li>
          <li :class="ceilingDesignlActive">
            <a href="/services/ceilingdesign"
              >Ceiling design and installation services</a
            >
          </li>
          <li :class="renovationsActive">
            <a href="/services/renovations">General renovations services</a>
          </li>
          <li :class="stoneCladdingActive">
            <a href="/services/stonecladding"
              >Stone cladding & raven services</a
            >
          </li>
        </ul>
      </div>
      <!-- Widget end -->

      <div class="widget">
        <div class="quote-item quote-border">
          <div class="quote-text-border">
            We are passionate for quality property building, decor and
            renovations, we beat all quotes on both pricing and quality neat
            finishing.
          </div>
        </div>
        <!-- Quote item end -->
      </div>
      <!-- Widget end -->
    </div>
    <!-- Sidebar end -->
  </div>
</template>

<script>
export default {
  name: "ServicesNavigation",
  props: {
    buildingActive: {
      type: String,
      default: ""
    },
    paintingingActive: {
      type: String,
      default: ""
    },
    electricalActive: {
      type: String,
      default: ""
    },
    landscapingActive: {
      type: String,
      default: ""
    },
    plumbingActive: {
      type: String,
      default: ""
    },
    tilingActive: {
      type: String,
      default: ""
    },
    swimmingActive: {
      type: String,
      default: ""
    },
    aluminiumActive: {
      type: String,
      default: ""
    },
    carpentryActive: {
      type: String,
      default: ""
    },
    fabricationActive: {
      type: String,
      default: ""
    },
    householdActive: {
      type: String,
      default: ""
    },
    architecturalActive: {
      type: String,
      default: ""
    },
    ceilingDesignlActive: {
      type: String,
      default: ""
    },
    renovationsActive: {
      type: String,
      default: ""
    },
    stoneCladdingActive: {
      type: String,
      default: ""
    }
  }
};
</script>
